setTimeout(() => {
    // Select all checkboxes
    const $checkboxes = $("input[type='checkbox']");

    $checkboxes.each(function() {
        $(this).on('click', function() {
            let cssCode="";

            const $parent = $(this).parent();
            if ($(this).is(':checked')) {
                $parent.removeClass('blank-checkbox');
                $parent.addClass('checked-checkbox');
            } else {
                $parent.removeClass('checked-checkbox');
                $parent.addClass('blank-checkbox');
            }
        });
    });

}, 2000);

$(document).ready(function(){

    //Auto play on document ready

    //MAKE LINKS OPEN EXTERNALLY
    $('a').each(function() {
        var a = new RegExp('/' + window.location.host + '/');
        if(!a.test(this.href)) {
            $(this).click(function(event) {
                event.preventDefault();
                event.stopPropagation();
                window.open(this.href, '_blank');
            });
        }
    });
    

    // Videos play/pause
    var videos = document.querySelectorAll('.banner-video');

    if (videos.length > 0) {
        let isplaying = videos[0].paused;

        $('#play-controller1').click(function () {
            if (!isplaying) {
                videos[0].play().then().catch(function (err) {
                    alert(err);
                });
                videos[1].play().then().catch(function (err) {
                    alert(err);
                });
                $('#play-controller1').removeClass('off');
                $('#play-controller1').addClass('on');
                isplaying = !isplaying;
            } else {
                videos[0].pause();
                videos[1].pause();
                $('#play-controller1').removeClass('on');
                $('#play-controller1').addClass('off');
                isplaying = !isplaying;
            }
        });

        $('#play-controller1').on("tap", function () {
            if (!isplaying) {
                videos[0].play().then().catch(function (err) {
                    alert(err);
                });
                videos[1].play().then().catch(function (err) {
                    alert(err);
                });
                $('#play-controller1').removeClass('off');
                $('#play-controller1').addClass('on');
                isplaying = !isplaying;
            } else {
                videos[0].pause();
                videos[1].pause();
                $('#play-controller1').removeClass('on');
                $('#play-controller1').addClass('off');
                isplaying = !isplaying;
            }
        });
    }

    // hover workaround 


    let videoButtons = document.querySelectorAll('.video-control');
    let titles = document.querySelectorAll('.text-banner')

    if(videoButtons.length > 0 && titles.length > 0){
        for(let button of videoButtons){
            button.addEventListener('mouseenter', ()=>{
               titles[0].style="color:white !important";
               titles[1].style="color:white !important";
            });

            button.addEventListener('mouseleave', ()=>{
                titles[0].style="";
                titles[1].style="";
            })
        }
    }
        
});


$(document).ready(function() {

    if($(".custom-datepicker").length){  
        displayDatePicker();
        }
        
    function displayDatePicker(){
    $(".custom-datepicker").attr("type","");
    
    $(".custom-datepicker").datepicker({
        
        inline: true,
        showOtherMonths: true,
        minDate: new Date(),
        dayNamesMin:['Sun','Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dateFormat: 'dd/mm/yy',
        nextText: "",
        prevText: "",
        selectOtherMonths: true,
        monthNamesShort: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ],
        onChangeMonthYear: function(){
            setTimeout(()=>{
                $(".ui-corner-all").removeAttr("title")
                $(".ui-icon-circle-triangle-e").html('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" class="dp__icon"><path d="M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"></path></svg>')
                $(".ui-icon-circle-triangle-w").html('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" class="dp__icon"><path d="M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"></path></svg>')
            },50)
        }
    });

    $(".custom-datepicker").attr("placeholder","dd/mm/yyyy");

    $(".custom-datepicker").click(()=>{
        $(".ui-corner-all").removeAttr("title")
        $(".ui-icon-circle-triangle-e").html('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" class="dp__icon"><path d="M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"></path></svg>')
        $(".ui-icon-circle-triangle-w").html('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" class="dp__icon"><path d="M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"></path></svg>')    
    })

    var site_domain = window.location.protocol + '//' + window.location.hostname;

    var icon  = $('<img class="fa-calendar custom-calendar-icon" src="' + site_domain+'/wp-content/uploads/2024/07/calendar.svg" />');
    $(".custom-datepicker").parent().append(icon);

    }

});

// styling links in footer menu
document.addEventListener('DOMContentLoaded', function() {
    const currentPath = window.location.pathname; 


    const menuLinks = document.querySelectorAll('footer .main-menu a');

    menuLinks.forEach(link => {
        const linkPath = new URL(link.href).pathname; 

        
        if ((currentPath === '/' || currentPath === '') && (linkPath === '/' || linkPath === '')) {
            link.classList.add('active-link');
        }
        
        else if (currentPath.startsWith(linkPath) && linkPath !== '/') {
            link.classList.add('active-link');
        }
    });
});


// style cookie law banner
document.addEventListener("DOMContentLoaded", function() {
 
    const lawbtn = document.getElementById("cookie-law-btn"); 
    const contentDiv = document.querySelector(".law-bar-content");

    if (lawbtn && contentDiv) {
        contentDiv.appendChild(lawbtn);
    }
});



